const features = [
  {
    id: 1,
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '91年国产影片视频采用多重安全防护机制，确保你在浏览91免费在线视频时信息安全无忧。所有片源经过严格审核，杜绝恶意内容，让你放心享受91在线观看免费的乐趣。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '依托全球CDN加速网络，91精品视频在线播放实现秒级加载、高清流畅不缓冲。无论是91免费视频网站还是91麻豆免费视频网站内容，都能在手机和电脑上畅快播放。',
  },
  {
    id: 3,
    icon: 'ri-eye-line',
    title: '完全免费',
    desc: '坚持免费观影理念，91在线免费播放无需会员、无需付费、无需订阅。所有91福利在线视频资源向全体用户开放，真正做到让每个人都能享受高品质国产影片。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="section-scroll py-14 md:py-20 bg-gray-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-red-600 text-xs md:text-sm font-semibold tracking-widest uppercase mb-2">为什么选择我们</p>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">平台特色</h2>
          <p className="mt-2 text-gray-500 text-sm md:text-base max-w-lg mx-auto">
            三大核心优势，为你打造极致的91免费看视频观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group bg-white rounded-xl p-6 md:p-8 border border-gray-100 hover:border-red-200 transition-all duration-300 text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-red-50 flex items-center justify-center mx-auto mb-4 group-hover:bg-red-600 transition-colors duration-300">
                <i className={`${feature.icon} text-red-600 text-2xl md:text-3xl group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-sm md:text-base text-gray-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}